import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-1989f7ca"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "question-header"
};
var _hoisted_3 = {
  key: 0,
  class: "question-image-box"
};
var _hoisted_4 = {
  key: 1,
  class: "question-save-area"
};
var _hoisted_5 = {
  class: "save-area"
};
var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 保存 ");
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "save-tips"
  }, "*请务必保存后再提交试卷", -1);
});
var _hoisted_8 = {
  class: "question-content-box"
};
var _hoisted_9 = ["required"];
var _hoisted_10 = {
  class: "index"
};
var _hoisted_11 = {
  class: "name"
};
var _hoisted_12 = {
  class: "bottom-content"
};
var _hoisted_13 = {
  class: "flex-title"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name",
    required: "true"
  }, "作品名称：", -1);
});
var _hoisted_15 = {
  class: "title"
};
var _hoisted_16 = {
  key: 0,
  class: "flex-title"
};
var _hoisted_17 = ["required"];
var _hoisted_18 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CustomAudio = _resolveComponent("CustomAudio");
  var _component_Image = _resolveComponent("Image");
  var _component_a_button = _resolveComponent("a-button");
  var _component_QsFileUpload = _resolveComponent("QsFileUpload");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  var _component_a_input = _resolveComponent("a-input");
  var _component_a_textarea = _resolveComponent("a-textarea");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.question.audioUrl ? (_openBlock(), _createBlock(_component_CustomAudio, {
    key: 0,
    audioUrl: _ctx.question.audioUrl
  }, null, 8, ["audioUrl"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.question.content), 1)]), _ctx.question.picUrl ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_Image, {
    src: _ctx.question.picUrl,
    alt: "question image"
  }, null, 8, ["src"])])) : _createCommentVNode("", true), !_ctx.answerMode ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
    size: "large",
    type: "primary",
    shape: "round",
    class: "save-btn",
    onClick: _ctx.onSaveAction
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["onClick"]), _hoisted_7])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["question-content", {
      'question-content-block': !_ctx.answerMode
    }])
  }, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: 40
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerRules, function (item, index) {
        return _openBlock(), _createBlock(_component_a_col, {
          span: 12,
          style: {
            "margin-bottom": "16px"
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
              class: "top-content",
              required: item.fileTypeRequired
            }, [_createElementVNode("span", _hoisted_10, _toDisplayString(index + 1) + ".", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(item.fileDescription), 1)], 8, _hoisted_9), _createElementVNode("div", _hoisted_12, [_createVNode(_component_QsFileUpload, {
              index: index,
              optionData: item,
              accept: item.fileType,
              limitSize: item.fileByte,
              limitDuration: item.durationSecond,
              userAnswer: item.userAnswer,
              answerMode: _ctx.answerMode,
              onOnUploaded: _ctx.onFileUploaded
            }, null, 8, ["index", "optionData", "accept", "limitSize", "limitDuration", "userAnswer", "answerMode", "onOnUploaded"])])])];
          }),
          _: 2
        }, 1024);
      }), 256))];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_input, {
    value: _ctx.attachmentConfig.title,
    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.attachmentConfig.title = $event;
    }),
    valueModifiers: {
      trim: true
    },
    class: "desc",
    placeholder: "请输入作品名称",
    size: "large",
    disabled: _ctx.answerMode
  }, null, 8, ["value", "disabled"])])]), _ctx.showIntroduction ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("span", {
    class: "name",
    required: _ctx.mustFillIntroduction
  }, "作品简介：", 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [_createVNode(_component_a_textarea, {
    size: "large",
    allowClear: "",
    maxlength: 400,
    showCount: "",
    value: _ctx.attachmentConfig.summary,
    "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.attachmentConfig.summary = $event;
    }),
    placeholder: "请输入作品简介",
    rows: 5,
    disabled: _ctx.answerMode,
    style: {
      "width": "480px"
    }
  }, null, 8, ["value", "disabled"])])])) : _createCommentVNode("", true)], 2)]);
}